import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import { loginUser } from '@store/reducers/auth';
import { setWindowClass } from '@app/utils/helpers';
import * as Yup from 'yup';
import { constant } from '@app/utils/constant';
import Cookies from 'js-cookie';

import { Form, InputGroup } from 'react-bootstrap';
import { loginByAuth, Get365AuthorizationUrl, Verify365Authorization } from '../../services/auth';

const Login = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const authcode = (searchParams) ? searchParams.get('code') : "";
  const ref = searchParams.get('ref');
  const [isAuthLoading, setAuthLoading] = useState(false);
  const [auth365LoginUrl, setAuth365LoginUrl] = useState(false);

  useEffect(() => {
    if (authcode != "" && authcode != null) {
      let redirecturl = Cookies.get('ref');
      Verify365AuthorizationCode(authcode, redirecturl);
    }
    if (ref) {
      Cookies.set('ref', ref, { domain: constant.Cookie_Domain, secure: constant.Cookie_Secure, sameSite: constant.Cookie_SameSite });
    } else if(authcode == "" || authcode == null) {
      Cookies.remove('ref', { domain: constant.Cookie_Domain, secure: constant.Cookie_Secure, sameSite: constant.Cookie_SameSite });
    }
    Get365AuthorizationLink();
  }, []);

  const Get365AuthorizationLink = () => {
    Get365AuthorizationUrl().then(function (res) {
      const resp = res.data;
      if (resp.Acknowledge == 1 && resp.ApplicationUrl) {
        setAuth365LoginUrl(resp.ApplicationUrl + constant.Get365RedirectUri);
      }
    }).catch(err => {
      toast.error('Eror on Get365AuthorizationUrl');
      return false;
    });
  };

  const Verify365AuthorizationCode = (authcode: any, redirect: string = '') => {
    setAuthLoading(true);
    Verify365Authorization(authcode).then(function (res) {
      const resp = res.data;
      if (resp.Acknowledge == 1 && resp.Token) {
        toast.success('Login is Successful');
        dispatch(loginUser(resp.Token));
        // if (redirect) {
        //   window.location.href = window.atob(redirect);
        // } else {
        //   navigate('/');
        // }
      } else {
        toast.error(resp.Error ? resp.Error : 'Invalid Login Details');
        navigate('/login');
      }
      setAuthLoading(false);
    }).catch(err => {
      toast.error('Error on ' + JSON.stringify(err));
      return false;
    });
  };

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const login = async (email: string, password: string, redirect: string = '') => {
    try {
      setAuthLoading(true);
      const resp: any = await loginByAuth(email, password);
      console.log('ee');
      console.log(resp);
      setAuthLoading(false);
      if (resp.Acknowledge == 1 && resp.Token && resp.Token != "") {
        let token = resp.Token;
        toast.success('Login is Successful');
        dispatch(loginUser(token));
        // if (redirect) {
        //    window.location.href = window.atob(redirect);
        // } else {
        //   navigate('/');
        // }
      } else if (resp.Acknowledge == 0 && resp.Error && resp.Error != "") {
        toast.error(resp.Error == 'Unauthorised' ? 'Invalid Login Details' : resp.Error);
      } else {
        toast.error('Invalid Login Details');
      }
    } catch (error: any) {
      setAuthLoading(false);
      toast.error(error.message || 'Failed');
    }
  };

  const { handleChange, values, handleSubmit, touched, errors } = useFormik({
    initialValues: {
      email: '',
      password: ''
    },
    validationSchema: Yup.object({
      email: Yup.string().email('Invalid email address').required('Required'),
      password: Yup.string()
        .min(5, 'Must be 5 characters or more')
        .max(30, 'Must be 30 characters or less')
        .required('Required')
    }),
    onSubmit: (values) => {
      login(values.email, values.password, ref);
    }
  });

  setWindowClass('hold-transition login-page');

  return (
    <div className="login-box">
      <div className="card card-outline card-primary">
        <div className="card-header text-center">
          <Link to="/" className="h1">
            <img src="/img/logo.svg" alt='Slomins' style={{ width: "50%" }} />
          </Link>
        </div>
        <div className="card-body">
          <p className="login-box-msg">Sign in to start your session</p>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <InputGroup className="mb-3">
                <Form.Control
                  id="email"
                  name="email"
                  type="email"
                  placeholder="Email"
                  onChange={handleChange}
                  value={values.email}
                  isValid={touched.email && !errors.email}
                  isInvalid={touched.email && !!errors.email}
                />
                {touched.email && errors.email ? (
                  <Form.Control.Feedback type="invalid">
                    {errors.email}
                  </Form.Control.Feedback>
                ) : (
                  <InputGroup.Append>
                    <InputGroup.Text>
                      <i className="fas fa-envelope" />
                    </InputGroup.Text>
                  </InputGroup.Append>
                )}
              </InputGroup>
            </div>
            <div className="mb-3">
              <InputGroup className="mb-3">
                <Form.Control
                  id="password"
                  name="password"
                  type="password"
                  placeholder="Password"
                  onChange={handleChange}
                  value={values.password}
                  isValid={touched.password && !errors.password}
                  isInvalid={touched.password && !!errors.password}
                />
                {touched.password && errors.password ? (
                  <Form.Control.Feedback type="invalid">
                    {errors.password}
                  </Form.Control.Feedback>
                ) : (
                  <InputGroup.Append>
                    <InputGroup.Text>
                      <i className="fas fa-lock" />
                    </InputGroup.Text>
                  </InputGroup.Append>
                )}
              </InputGroup>
            </div>

            <div className="row">
              <div className="col-8">
                <div className="icheck-primary">
                  <input type="checkbox" id="remember" />
                  <label htmlFor="remember">
                    Remember Me
                  </label>
                </div>
              </div>
              <div className="col-4">
                <button type="submit" data-loading={isAuthLoading} className="btn btn-primary btn-block">
                  {isAuthLoading ?
                    <div className="center-items p-0"><div className="spinner-border spinner-border-sm" role="status"><span className="sr-only">Loading...</span></div></div>
                    : 'Sign In'}
                </button>
              </div>
            </div>
          </form>
          {auth365LoginUrl &&
            <div className="social-auth-links text-center mb-3">
              <p>- OR -</p>
              <a href={auth365LoginUrl ? auth365LoginUrl : '#'} className="btn btn-block btn-primary ms-login-btn">
                <i className="fab fa-microsoft mr-2"></i> Sign in With Microsoft
              </a>
            </div>
          }
        </div>
      </div>
    </div>
  );
};

export default Login;
